<template>
  <div id="app">
    <!--<img src="./assets/logo.png">-->
    <manageBox>
      <transition name="fade" mode="out-in">
        <router-view />
      </transition>
      
    </manageBox>
  </div>
</template>

<script>
import manageBox from "@/components/manageBox";
export default {
  components:{
    manageBox
  },
  name: "App",
};
</script>

<style>
* {
  margin: 0;
  padding: 0;
}

ul li {
  list-style: none;
}

.flex {
  display: flex;
  align-items: center;
}

.paytypeColor{
  font-size: 8px;
  color: #999;
}


.el-table__fixed-right{
  height: 100% !important; 
 }


.Btn {
  width: 70px;
  height: 32px;
  border-radius: 5px;
  color: #ffffff;
  border: 0;
}

#add_item {
  width: 80%;
  height: 40px;
  line-height: 40px;
  text-align: center;
  padding: 10px;
  border: 2px dashed #dedede;
  color: #888;
  font-size: 16px;
  margin-top: 20px;
  cursor: pointer;
}


.fade-enter-active,
.fade-leave-active {
  transition: all 0.5s ease;
}

.fade-enter,
.fade-leave-active {
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/App.vue